// extracted by mini-css-extract-plugin
module.exports = {"tagTypeList":"TagTypeList_tagTypeList__1JmV5","tagTypeItem":"TagTypeList_tagTypeItem__1oXdN"};